import { PartnerOffering } from "../data/partner_offering";

export function getPartnerOfferingName(partnerOffering: PartnerOffering) {
  return partnerOffering.offeringTitle || partnerOffering.name;
}
